import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid || status === "paid" || attempts > 10) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setStatus(data.payment_status);
        setAttempts(a => a + 1);
      } catch {}
    }, 2000);
    return () => clearTimeout(t);
  }, [sid, status, attempts]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center border border-slate-200">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto mb-4"/>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Pagamento Confirmado!</h1>
            <p className="text-slate-500 mt-2">A mensalidade foi registrada com sucesso.</p>
          </>
        ) : (
          <>
            <Loader2 className="w-16 h-16 text-rose-600 mx-auto mb-4 animate-spin"/>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Confirmando pagamento...</h1>
            <p className="text-slate-500 mt-2">Aguarde alguns instantes.</p>
          </>
        )}
        <Button onClick={()=>navigate("/financeiro")} className="mt-6 bg-rose-600 hover:bg-rose-700">Voltar ao painel</Button>
      </Card>
    </div>
  );
}
